const base = require("./base");
module.exports = {
  ...base.apiFactory("/"),
  _chat_190606: "https://test-frontend.cjdropshipping.com/chat/",
  _phone_190606: "http://m.cjdropshipping.offline.pre.com/",
  "productSku": "https://cj-oss-test.oss-cn-hangzhou.aliyuncs.com/", // 商品详情数据测试环境oss地址
  "productDetail": "https://cj-oss-test.oss-cn-hangzhou.aliyuncs.com/", // 商品详情数据测试环境oss地址
  "supplierInfo": "https://cj-oss-test.oss-cn-hangzhou.aliyuncs.com/", // 供应商信息oss地址
};
